import birthdayPartyGrid1 from 'assets/img/birthday-party-grid-1.jpg'
import birthdayPartyGrid2 from 'assets/img/birthday-party-grid-2.jpg'
import birthdayPartyGrid3 from 'assets/img/birthday-party-grid-3.jpg'
import birthdayPartyGrid4 from 'assets/img/birthday-party-grid-4.jpg'
import birthdayPartyBanner from 'assets/img/birthday-party-banner.jpg'

import lunchHeroImg from 'assets/img/business-lunch-hero.jpg'
import lunchCatering1 from 'assets/img/businesslunch-catering-1.jpg'
import lunchCatering2 from 'assets/img/businesslunch-catering-2.jpg'
import lunchCatering3 from 'assets/img/businesslunch-catering-3.jpg'
import lunchCatering4 from 'assets/img/businesslunch-catering-4.jpg'

import businessLunchFCHeroImg from 'assets/img/business-lunch-food-court-hero.jpg'
import businessLunchFCGridImage1 from 'assets/img/business-lunch-food-court-1.jpg'
import businessLunchFCGridImage2 from 'assets/img/business-lunch-food-court-2.jpg'
import businessLunchFCGridImage3 from 'assets/img/business-lunch-food-court-3.jpg'
import businessLunchFCGridImage4 from 'assets/img/business-lunch-food-court-4.jpg'

import partyCatering1 from 'assets/img/party-catering-1.jpg'
import partyCatering2 from 'assets/img/party-catering-2.jpg'
import partyCatering3 from 'assets/img/party-catering-3.jpg'
import partyCatering4 from 'assets/img/party-catering-4.jpg'

import campusCatering1 from 'assets/img/campus-food-truck-catering-2.jpeg'
import campusCatering2 from 'assets/img/campus-catering-with-food-trucks-3.jpeg'
import campusCatering3 from 'assets/img/campus-food-truck-catering-4.jpeg'
import campusCatering4 from 'assets/img/food-truck-campus-events.jpg'

import conferenceCatering1 from 'assets/img/conference-catering-1.jpg'
import conferenceCatering2 from 'assets/img/conference-catering-2.jpg'
import conferenceCatering3 from 'assets/img/conference-catering-3.jpg'
import conferenceCatering4 from 'assets/img/conference-catering-4.jpg'

import corporateCatering1 from 'assets/img/corporate-catering-1.jpg'
import corporateCatering2 from 'assets/img/corporate-catering-2.jpg'
import corporateCatering3 from 'assets/img/corporate-catering-3.jpg'
import corporateCatering4 from 'assets/img/corporate-catering-4.jpg'

import filmProductionGrid1 from 'assets/img/film-production-grid-1.jpg'
import filmProductionGrid2 from 'assets/img/film-production-grid-2.jpg'
import filmProductionGrid3 from 'assets/img/film-production-grid-3.jpg'
import filmProductionGrid4 from 'assets/img/film-production-grid-4.jpg'
import filmProductionGrid5 from 'assets/img/film-production-grid-5.jpg'
import filmProductionGrid6 from 'assets/img/film-production-grid-6.jpg'

import weddingCatering1 from 'assets/img/wedding-catering-1.jpg'
import weddingCatering2 from 'assets/img/wedding-catering-2.jpg'
import weddingCatering4 from 'assets/img/wedding-catering-4.jpg'

import holidayPartyCatering1 from 'assets/img/holiday-party-catering-1.jpg'
import holidayPartyCatering2 from 'assets/img/holiday-party-catering-2.jpg'
import holidayPartyCatering3 from 'assets/img/holiday-party-catering-3.jpg'

import universityImage from 'assets/img/university-grid-4.jpg'

const commonMetaTags = {
  "@type": "FoodService",
  "isSimilarTo": [
    {
        "@type": "FoodService",
        "url": "https://roaminghunger.com/food-truck-catering/bbq-food-truck-catering/",
        "name": "BBQ Truck Catering",
        "@id": "https://roaminghunger.com/food-truck-catering/bbq-food-truck-catering/#FoodService"
    },
    {
        "@type": "FoodService",
        "url": "https://roaminghunger.com/food-truck-catering/pizza-truck-catering/",
        "name": "Pizza Truck Catering",
        "@id": "https://roaminghunger.com/food-truck-catering/pizza-truck-catering/#FoodService"
    }
],
"additionalType": [
    "https://www.wikidata.org/wiki/Q3303463",
    "https://www.wikidata.org/wiki/Q6887072"
],

}

const occasionSEOData = {
  birthday:  {
    images: [
      birthdayPartyGrid1,
      birthdayPartyGrid2,
      birthdayPartyGrid3,
      birthdayPartyGrid4,
      birthdayPartyBanner
    ],
    description: "Book the best birthday party catering near you. Need catering for a kids birthday party? Or 40th birthday party? We'll help you cater for any birthday milestone",
    name: "Birthday Party Catering",
    slug: 'birthday-party-catering'
  },
  businessLunchCatering: {
    images: [
      lunchHeroImg,
      lunchCatering1,
      lunchCatering2,
      lunchCatering3,
      lunchCatering4,
    ],
    description: "We make catering business lunches easy. From buffet style to prepackaged meals, work with a dedicated agent to get delicious lunch catering options that fit your office.",
    name: "Business Lunch Catering",
    slug: 'business-lunch-catering'
  },
  businessLunchFoodCourt: {
    images: [
      businessLunchFCHeroImg,
      businessLunchFCGridImage1,
      businessLunchFCGridImage2,
      businessLunchFCGridImage3,
      businessLunchFCGridImage4,
    ],
    description: "Give your employees a great business lunch by organizing a rotating schedule of food trucks to serve at your office.",
    name: "Business Lunch Food Court",
    slug: 'business-lunch-food-court'
  },
  campus:  {
    images: [
      campusCatering1,
      campusCatering2,
      campusCatering3,
      campusCatering4,
    ],
    description: "Food trucks are a great university or campus catering option. Roaming Hunger can help coordinate food trucks to cater any university or school event across the country.",
    name: "On-Campus Food Truck Catering",
    slug: 'campus-catering'
  },
  conference: {
    images: [],
    description: "Food trucks are a great foodservice option for your conference, or convention. Our venders offer full service catering including breakfast, lunch, and dinner.",
    name: "Food Truck Conference and Event Catering",
    faq: [
      conferenceCatering1,
      conferenceCatering2,
      conferenceCatering3,
      conferenceCatering4,
    ],
    slug: 'conference-catering'
  },
  corporate: {
    images: [
      corporateCatering1,
      corporateCatering2,
      corporateCatering3,
      corporateCatering4
    ],
    description: "Book food trucks for your next office lunch catering, employee appreciation day, corporate event, or business meeting.",
    name: "Corporate Catering with Delicious Food Trucks",
    faq: [
      {
      '@type': 'Question',
      'name': 'How much does food truck catering for corporate events cost?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Food truck catering packages typically range from $1,000-$3,000, depending on guest count, cuisine, and length of service.'
      }
      },
      {
        '@type': 'Question',
        'name': 'What are some popular cuisines for corporate food truck catering?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<p>Here are our top 10 most requested food truck cuisines:</p> <ul> <li> <a href=\'https://roaminghunger.com/food-truck-catering/taco-truck-catering/\'>Tacos</a> (Mexican and Fusion) </li> <li> <a href=\'https://roaminghunger.com/food-truck-catering/burger-catering-truck/\'>Burgers</a> <li> <a href=\'https://roaminghunger.com/food-truck-catering/bbq-food-truck-catering/\'>BBQ</a> </li> <li> <a href=\'https://roaminghunger.com/food-truck-catering/pizza-truck-catering/\'>Pizza</a> </li> <li>Sandwiches</li> <li>Asian</li> <li>Dessert&nbsp;</li> <li>Healthy Food</li> <li>Mediterranean</li> <li>Breakfast</li> </ul> <p>We also get many requests for Vegetarian and Vegan options, which many food trucks can accommodate.</p>'
        }
      },
      {
        '@type': 'Question',
        'name': 'How do I get party catering packages for food trucks near me?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<p>If your event details are confirmed, and your budget meets the minimum (see above), you can get catering packages and quotes by submitting a catering request.</p> <p>Your request will be sent to food trucks in your area, and available trucks will submit a catering package with pricing and menu. From there you can choose the best catering package for you.</p>'
        }
      },
      {
        '@type': 'Question',
        'name': 'Why should I use Roaming Hunger?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<p>Roaming Hunger is the largest website for food trucks and mobile food businesses. Since 2009, we&rsquo;ve helped thousands of companies and individuals book food trucks for catering and events. Today, we have over 23,000 independent food trucks, trailers, carts, and pop-ups on our site.</p> <ul> <li> <p><strong>Variety</strong>&nbsp;- Our network consists of hundreds of local vendors in every major city, totaling 23,000+ nationally.</p> </li> <li> <p><strong>Save Time</strong>&nbsp;- Why have 100 conversations to find one food truck when you can have one conversation to find 100 food trucks?!</p> </li> <li> <p><strong>Speed</strong>&nbsp;- Whether you are ready to book one day or one month out from your event, we will provide every available food truck option.</p> </li> <li> <p><strong>Quality Options </strong>- All the food trucks we work with are gourmet, vetted, licensed, proven and reliable.</p> </li> <li> <p><strong>Service</strong> - Every catering is protected by our 100% Roaming Hunger Service Guarantee. If the caterer does not show, we&rsquo;ll get you a replacement caterer or refund 100% of your money.</p> </li> </ul>'
          }
      },
    ],
    slug: 'corporate-catering'
  },
  filmProductionGeneral: {
    images: [
      filmProductionGrid1,
      filmProductionGrid2,
      filmProductionGrid3,
      filmProductionGrid4,
      filmProductionGrid5,
      filmProductionGrid6,
    ],
    description: "Looking for flexible, mobile film production catering? Food trucks are a great way to provide TV/movie set catering across the country. Grab fun film catering",
    name: "Catering for TV and Film Production (Food Trucks)",
    slug: 'film-production'
  },
  wedding:  {
    images: [
      weddingCatering1,
      weddingCatering2,
      weddingCatering4,
    ],
    description: "We’re your culinary matchmaker. At Roaming Hunger, our technology and expertise pairs you with your perfect catering experience.",
    name: "Food Truck Wedding Catering",
    slug: 'wedding-food-truck-catering'
  },
  holidayParty:  {
    images: [
      holidayPartyCatering1,
      holidayPartyCatering2,
      holidayPartyCatering3,
    ],
    description: "The holiday season means many things. To us, it means the grocery stores start playing “Jingle Bells”, menorahs appear in window sills, and the movie Elf is constantly on TV. Whatever you celebrate...",
    name: "Holiday Party Catering With Food Trucks",
    slug: 'holiday-party-catering'
  },
  party: {
    images: [
      partyCatering1,
      partyCatering2,
      partyCatering3,
      partyCatering4,
    ],
    description: "Food Truck Catering for Parties",
    name: "Party Catering",
    faq: [
      {
        '@type': 'Question',
        'name': 'How much does food truck catering for parties cost?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<p>On average food truck for a party costs $1,541, and pricing for a catering package can typically range $800-$2,500.&nbsp;</p> <p>Cuisine affects the costs of your food truck catering more than any other factor. Here are typical per person costs along with average minimums.</p> <div align=\'left\'> <table> <tbody> <tr> <td> <strong>Cuisine</strong> </td> <td> <strong>Average Price per Person</strong> </td> <td> <strong>1-100 Eaters (Minimum)</strong> </td> </tr> <tr> <td> <a href=\'https://roaminghunger.com/food-truck-catering/taco-truck-catering/\'>Taco Truck Catering</a> </td> <td> $10-15 </td> <td> $1,000 </td> </tr> <tr> <td> <a href=\'https://roaminghunger.com/food-truck-catering/burger-catering-truck/\'>Burger</a>,&nbsp;<a href=\'https://roaminghunger.com/food-truck-catering/bbq-food-truck-catering/\'>BBQ</a>, &amp;&nbsp;<a href=\'https://roaminghunger.com/food-truck-catering/pizza-truck-catering/\'>Pizza</a> Truck Catering </td> <td> $15-25 </td> <td> $1,500 </td> </tr> <tr> <td> Dessert Truck Catering </td> <td> $8-20 </td> <td> $800 </td> </tr> <tr> <td> Beverage Truck Catering </td> <td> $8-20 </td> <td> $800 </td> </tr> </tbody> </table> </div> <p>Use our&nbsp;<a href=\'https://roaminghunger.com/food-truck-catering/#calculator\'>Food Truck Catering Cost Calculator</a></p> <p>Adding drinks or dessert options (with a savory food truck) will increase the price per person by $4-$5.</p> <p>If you&rsquo;re having a small party of 50 guests or less, you&rsquo;ll probably be affected by the food truck catering minimums, and the price per person will increase.</p> <p>Typical service times for a party are 2-3 hours. Additional hours will increase total costs. Travel fees can also affect pricing. Food trucks may charge a per mile fee if your event is outside their normal travel radius (20-30 miles).&nbsp;</p> <p>This data is based on actual Roaming Hunger data, and does not include any taxes or fees.</p>'
        }
      },
      {
        '@type': 'Question',
        'name': 'What are some popular cuisines for food truck party catering?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<p>Here are our top 10 most requested food truck cuisines:</p> <ul> <li> <a href=\'https://roaminghunger.com/food-truck-catering/taco-truck-catering/\'>Tacos</a> (Mexican and Fusion) </li> <li> <a href=\'https://roaminghunger.com/food-truck-catering/burger-catering-truck/\'>Burgers</a> <li> <a href=\'https://roaminghunger.com/food-truck-catering/bbq-food-truck-catering/\'>BBQ</a> </li> <li> <a href=\'https://roaminghunger.com/food-truck-catering/pizza-truck-catering/\'>Pizza</a> </li> <li>Sandwiches</li> <li>Asian</li> <li>Dessert&nbsp;</li> <li>Healthy Food</li> <li>Mediterranean</li> <li>Breakfast</li> </ul> <p>We also get many requests for Vegetarian and Vegan options, which many food trucks can accommodate.</p>'
        }
      },
      {
        '@type': 'Question',
        'name': 'How do I get party catering packages for food trucks near me?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<p>If your event details are confirmed, and your budget meets the minimum (see above), you can get catering packages and quotes by submitting a catering request.</p> <p>Your request will be sent to food trucks in your area, and available trucks will submit a catering package with pricing and menu. From there you can choose the best catering package for you.</p>'
        }
      },
      {
        '@type': 'Question',
        'name': 'Why should I use Roaming Hunger?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<p>Roaming Hunger is the largest website for food trucks and mobile food businesses. Since 2009, we&rsquo;ve helped thousands of companies and individuals book food trucks for catering and events. Today, we have over 23,000 independent food trucks, trailers, carts, and pop-ups on our site.</p> <ul> <li> <p><strong>Variety</strong>&nbsp;- Our network consists of hundreds of local vendors in every major city, totaling 23,000+ nationally.</p> </li> <li> <p><strong>Save Time</strong>&nbsp;- Why have 100 conversations to find one food truck when you can have one conversation to find 100 food trucks?!</p> </li> <li> <p><strong>Speed</strong>&nbsp;- Whether you are ready to book one day or one month out from your event, we will provide every available food truck option.</p> </li> <li> <p><strong>Quality Options </strong>- All the food trucks we work with are gourmet, vetted, licensed, proven and reliable.</p> </li> <li> <p><strong>Service</strong> - Every catering is protected by our 100% Roaming Hunger Service Guarantee. If the caterer does not show, we&rsquo;ll get you a replacement caterer or refund 100% of your money.</p> </li> </ul>'
          }
      }
    ],
    slug: 'party-catering'
  },
  university: {
    images: [
      universityImage,
    ],
    description: "Cater with food trucks for any type of event, including birthdays, graduation parties, house warming, anniversaries and Bar/Bat Mitzvahs.",
    name: "Food Truck Catering for Universities (with free cost calculator)",
    slug: 'university-catering'
  }
}

export default function getGoogleMetaTags(occasion) {
  const seoData = occasionSEOData[occasion]

  const result = { ...commonMetaTags }

  if (seoData.faq) {
    result['subjectOf'] = {
      '@type': 'FAQPage',
      'mainEntity': seoData.faq,
      'name': `${seoData.name} FAQ`,
      '@id': `https://roaminghunger.com/food-truck-catering/${seoData.slug}/#FAQPage`
    }
  }

  result['name'] =  seoData.name
  result['image'] = seoData.images
  result['description'] = seoData.description
  result['url'] = `https://roaminghunger.com/food-truck-catering/${seoData.slug}/`
  result['@id'] = `https://roaminghunger.com/food-truck-catering/${seoData.slug}/#FoodService`

  return JSON.stringify(result) 
}
